import { Flex, FlexProps } from '../../../atoms';

type Props = FlexProps;

export function FlatCard(props: Props): JSX.Element {
  return (
    <Flex
      justifyContent="space-between"
      p="space_unit.x2"
      borderWidth="1px"
      borderColor="palette_gray.10"
      alignItems="center"
      w="100%"
      {...props}
    />
  );
}
